const name = {
    defaultMessage: 'Deep Dark',
    description: 'Label for the deep dark GUI theme',
    id: 'tw.theme.gui.deepdark'
};

const guiColors = {
    "color-scheme": "dark",

    "ui-primary": "#050505",
    "ui-secondary": "#101010",
    "ui-tertiary": "#101010",

    "ui-modal-overlay": "#111111aa",
    "ui-modal-background": "#050505",
    "ui-modal-foreground": "#e0e0e0",
    "ui-modal-header-background": "#050505",
    "ui-modal-header-foreground": "#eeeeee",

    "ui-white": "#050505",

    "ui-black-transparent": "#ffffff26",

    "text-primary": "#eeeeee",

    "menu-bar-background": "#050505",
    "menu-bar-feedback": "white",
    "icon-style": "brightness(1)",

    "assets-background": "#050505",

    "input-background": "#101010",

    "popover-background": "#101010",

    "badge-background": "#16202c",
    "badge-border": "#203652",

    "fullscreen-background": "#050505",
    "fullscreen-accent": "#050505",

    "page-background": "#050505",
    "page-foreground": "#eeeeee",

    "project-title-inactive": "var(--ui-secondary)",
    "project-title-hover": "#eeeeee3f",

    "link-color": "#004488",

    "filter-icon-black": "invert(100%)",
    "filter-icon-gray": "grayscale(100%) brightness(1.7)",
    "filter-icon-white": "brightness(0) invert(100%)",

    "paint-filter-icon-gray": "brightness(1.7)",
};

const blockColors = {
    insertionMarker: '#cccccc',
    workspace: '#101010',
    toolboxSelected: '#101010',
    toolboxText: '#cccccc',
    toolbox: '#050505',
    flyout: '#050505',
    scrollbar: '#666666',
    valueReportBackground: '#101010',
    valueReportBorder: '#333333',
    valueReportForeground: '#eeeeee',
    contextMenuBackground: '#050505',
    contextMenuBorder: '#ffffff26',
    contextMenuForeground: '#eeeeee',
    contextMenuActiveBackground: '#2e2e2e',
    contextMenuDisabledForeground: '#666666',
    flyoutLabelColor: '#cccccc',
    checkboxInactiveBackground: '#222222',
    checkboxInactiveBorder: '#c8c8c8',
    buttonBorder: '#c6c6c6',
    buttonActiveBackground: '#222222',
    buttonForeground: '#cccccc',
    zoomIconFilter: 'invert(100%)',
    gridColor: 'transparent'
};

export {
    name,
    guiColors,
    blockColors
};
